import { __assign } from "tslib";
import { createApiKeysApi } from './index';
// tslint:disable-next-line:max-line-length
import { createFakeGetResponder, createFakePostResponder, createFakeDeleteResponder, createFakePutResponder } from '../../test-utils';
import { createHttpTestKit } from '../../http/test-kit';
export var createApiKeysApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createApiKeysApi('', fakeHttp);
    // @ts-ignore - Ignore the error here, or handle wildcard ('*') param
    var testKit = {
        whenGetApiKeys: function () {
            return createFakeGetResponder(fakeHttp, '/apiKeys');
        },
        whenAddApiKey: function (dto) {
            return createFakePostResponder(fakeHttp, "/apiKeys")(dto);
        },
        whenGetApiKey: function (id) {
            return createFakeGetResponder(fakeHttp, "/apiKeys/" + id);
        },
        whenDeleteApiKey: function (id) {
            return createFakeDeleteResponder(fakeHttp, "/apiKeys/" + id);
        },
        whenUpdateApiKey: function (dto) {
            return createFakePutResponder(fakeHttp, "/apiKeys/" + dto.id)(dto.data);
        }
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map